import { isDefined } from "../../Utils/utils";

const isAmountOne = (amount) => Number(amount) === 1;

export const shouldHidePositionAmountAndPriceUnit = (position) =>
  isAmountOne(position.amount) &&
  !isDefined(position.unit);

export const shouldHideQuantityAndPriceColumns = (positions) =>
  positions.length > 0 &&
  positions.every(
    (position) => shouldHidePositionAmountAndPriceUnit(position)
  );
